export default __webpack_public_path__ + "static/media/aayat.ab6562ad.jpg";